import { Injectable, inject } from '@angular/core';
import { Document, Role } from '../services/model';
import { AbstractCrudOperations, ServiceTransactionsEnum, RoleRequirements } from './abstract/abstract-crud-operations';
import { DocumentCreate } from './model';
import { AuthService } from './auth.service';

export enum DocumentTransactionsEnum {
  GET_ALL = 'document-get-all',
  GET_BY_ID = 'document-get-by-id',
  CREATE = 'document-create',
  UPDATE = 'document-update',
  DELETE = 'document-delete',
}

@Injectable({
  providedIn: 'root',
})
export class DocumentService extends AbstractCrudOperations<Document, DocumentCreate, Document> {
  protected override transactions: Record<ServiceTransactionsEnum, string> = {
    [ServiceTransactionsEnum.GET_ALL]: DocumentTransactionsEnum.GET_ALL,
    [ServiceTransactionsEnum.GET_BY_ID]: DocumentTransactionsEnum.GET_BY_ID,
    [ServiceTransactionsEnum.CREATE]: DocumentTransactionsEnum.CREATE,
    [ServiceTransactionsEnum.UPDATE]: DocumentTransactionsEnum.UPDATE,
    [ServiceTransactionsEnum.DELETE]: DocumentTransactionsEnum.DELETE,
  };

  override readonly resource = 'documents';

  protected override roleRequirements: RoleRequirements = {
    create: [Role.Admin, Role.Manager, Role.User],
    update: [Role.Admin, Role.Manager, Role.User],
    delete: [Role.Admin, Role.Manager, Role.User],
  };

  protected override authService = inject(AuthService);
}
